import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import React from 'react'
import { RELATIONSHIP_OPTIONS } from 'src/consumer/constants'
import { ATTENDANT_STYLES, GRID_CONFIG } from '../utils/patientFormConfig'
import { ArrayFormField } from './FormField'

export const PatientAttendants = ({
  attendants = [],
  onAdd,
  onUpdate,
  onRemove,
  editMode = true,
  validationHook,
}) => {
  const renderAttendant = (attendant, index, { onUpdate, onRemove, disabled }) => {
    const validation = validationHook?.getAttendantValidation(index)

    return (
      <div key={index} className="d-flex align-items-center gap-2 mb-2">
        <div className="d-flex flex-column" style={{ flex: 1 }}>
          <input
            style={ATTENDANT_STYLES.input}
            value={attendant?.name || ''}
            placeholder="Attendant Name"
            disabled={disabled}
            onChange={(e) => {
              if (!disabled) {
                onUpdate(index, 'name', e.target.value)
              }
            }}
          />
          {validation?.showError && (
            <small className="text-danger">{validation.errorMessage}</small>
          )}
        </div>

        <select
          value={attendant?.type}
          disabled={disabled}
          style={ATTENDANT_STYLES.select}
          onChange={(e) => {
            if (!disabled) {
              onUpdate(index, 'type', e.target.value)
            }
          }}
        >
          {RELATIONSHIP_OPTIONS.map((item, optionIndex) => (
            <option key={optionIndex} value={item.value}>
              {item.label}
            </option>
          ))}
        </select>

        <DeleteOutlineIcon
          style={{
            cursor: disabled ? 'not-allowed' : 'pointer',
            opacity: disabled ? 0.5 : 1
          }}
          onClick={() => {
            if (!disabled) {
              onRemove(index)
            }
          }}
        />
      </div>
    )
  }

  return (
    <ArrayFormField
      label="Attendants"
      items={attendants}
      onAdd={editMode ? onAdd : undefined}
      onRemove={editMode ? onRemove : undefined}
      onUpdate={editMode ? onUpdate : undefined}
      renderItem={renderAttendant}
      disabled={!editMode}
      gridConfig={GRID_CONFIG}
      AddIcon={AddCircleOutlineIcon}
    />
  )
}

export default PatientAttendants